import api from './api/axiosConfig';

const postService = {
  // Get all posts
  getPosts: async (params = {}) => {
    try {
      const response = await api.get('/posts/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching posts:', error);
      throw error;
    }
  },

  // Get a single post by slug or ID
  getPost: async (identifier) => {
    try {
      const response = await api.get(`/posts/${identifier}/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching post:', error);
      throw error;
    }
  },

  // Create a new post
  createPost: async (postData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(postData).forEach(key => {
        if (key === 'images' && Array.isArray(postData[key])) {
          // Handle images separately
          postData[key].forEach((image, index) => {
            formData.append('images', image);
          });
        } else if (key !== 'images') {
          formData.append(key, postData[key]);
        }
      });

      const response = await api.post('/posts/', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error creating post:', error);
      throw error;
    }
  },

  // Update a post
  updatePost: async (identifier, postData) => {
    try {
      const formData = new FormData();
      
      // Add basic fields
      Object.keys(postData).forEach(key => {
        if (key === 'images' && Array.isArray(postData[key])) {
          // Handle images separately
          postData[key].forEach((image, index) => {
            formData.append('images', image);
          });
        } else if (key !== 'images') {
          formData.append(key, postData[key]);
        }
      });

      const response = await api.put(`/posts/${identifier}/`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Error updating post:', error);
      throw error;
    }
  },

  // Delete a post
  deletePost: async (identifier) => {
    try {
      const response = await api.delete(`/posts/${identifier}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting post:', error);
      throw error;
    }
  },

  // Like/unlike a post
  toggleLike: async (postId) => {
    try {
      const response = await api.post(`/posts/${postId}/like/`);
      return response.data;
    } catch (error) {
      console.error('Error toggling like:', error);
      throw error;
    }
  },

  // Share a post
  sharePost: async (postId) => {
    try {
      const response = await api.post(`/posts/${postId}/share/`);
      return response.data;
    } catch (error) {
      console.error('Error sharing post:', error);
      throw error;
    }
  },

  // Get post comments
  getComments: async (postId) => {
    try {
      const response = await api.get(`/posts/${postId}/comments/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching comments:', error);
      throw error;
    }
  },

  // Add a comment
  addComment: async (postId, commentData) => {
    try {
      const payload = { ...commentData, post: postId };
      const response = await api.post(`/posts/comments/`, payload);
      return response.data;
    } catch (error) {
      console.error('Error adding comment:', error);
      throw error;
    }
  },

  // Update a comment
  updateComment: async (commentId, commentData) => {
    try {
      const response = await api.put(`/posts/comments/${commentId}/`, commentData);
      return response.data;
    } catch (error) {
      console.error('Error updating comment:', error);
      throw error;
    }
  },

  // Delete a comment
  deleteComment: async (commentId) => {
    try {
      const response = await api.delete(`/posts/comments/${commentId}/`);
      return response.data;
    } catch (error) {
      console.error('Error deleting comment:', error);
      throw error;
    }
  },

  // Follow/unfollow a user
  toggleFollow: async (userId) => {
    try {
      const response = await api.post(`/posts/users/${userId}/follow/`);
      return response.data;
    } catch (error) {
      console.error('Error toggling follow:', error);
      throw error;
    }
  },

  // Get user followers
  getFollowers: async (userId) => {
    try {
      const response = await api.get(`/posts/users/${userId}/followers/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching followers:', error);
      throw error;
    }
  },

  // Get user following
  getFollowing: async (userId) => {
    try {
      const response = await api.get(`/posts/users/${userId}/following/`);
      return response.data;
    } catch (error) {
      console.error('Error fetching following:', error);
      throw error;
    }
  },

  // Increment post views
  incrementViews: async (postId) => {
    try {
      const response = await api.post(`/posts/${postId}/increment-views/`);
      return response.data;
    } catch (error) {
      console.error('Error incrementing views:', error);
      throw error;
    }
  },
};

export default postService;
